import mixpanel from 'mixpanel-browser';
import type { Mixpanel } from 'mixpanel-browser';
import { Properties, TrackOptions } from './StackTrackerService';
import { PageViewData } from './BaseTrackingService';
export class MixPanelTrackerService implements TrackerService {
    protected mixpanelClient: Mixpanel;

    constructor() {
        const {
            public: { mixpanelToken },
        } = useRuntimeConfig();

        mixpanel.init(mixpanelToken);

        const mixpanelClient: Mixpanel = mixpanel;
        this.mixpanelClient = mixpanelClient;
    }

    track(event: string, properties?: Properties, options?: TrackOptions): void {
        this.mixpanelClient.track(event, properties, options?.beacon ? { send_immediately: true, transport: 'sendBeacon' } : undefined);
    }

    pageView(properties?: PageViewData): void {
        this.track('page_view', properties);
    }

    identify(userId: string, properties?: Properties): void {
        this.mixpanelClient.identify(userId);
        if (properties) this.mixpanelClient.people.set(properties);
    }

    setPersonProperties(properties: Properties): void {
        this.mixpanelClient.people.set(properties);
    }

    group(_type: string, _key: string, _properties?: Properties): void {}

    captureException(_error: unknown, _properties?: Properties): void {}

    reset(): void {
        this.mixpanelClient.reset();
    }
}
